const locationList = [
  {name: "Anthony Village", amt: "3500.00"},
  {name: "Yaba", amt: "3500.00"},
  {name: "Ajao Estate", amt: "3000.00"},
  {name: "Ikotun", amt: "4500.00"},
  {name: "Ilupeju", amt: "2000.00"},
  {name: "Oshodi", amt: "3500.00"},
  {name: "Mile2", amt: "4000.00"},
  {name: "Ketu", amt: "3500.00"},
  {name: "Isolo", amt: "3500.00"},
  {name: "Lagos Island", amt: "4500.00"},
  {name: "Magodo", amt: "3500.00"},
  {name: "Mushin", amt: "2500.00"},
  {name: "Ojota", amt: "3500.00"},
  {name: "Ojodu", amt: "3800.00"},
  {name: "Berger", amt: "4200.00"},
  {name: "Shomolu", amt: "3500.00"},
  {name: "Lagos Island", amt: "4500.00"},
  {name: "Epe", amt: "5000.00"},
  {name: "Lekki", amt: "4000.00"},
  {name: "Victoria Island", amt: "4500.00"},
  {name: "CMS", amt: "4500.00"},
  {name: "Ejigbo", amt: "3500.00"},
  {name: "Ebute Metta", amt: "3500.00"},
  {name: "Others", amt: "4500.00"},
];

export default locationList;
